<template>
  <div>
    <v-autocomplete
      :items="tags"
      v-model="values"
      dense
      flat
      clearable
      multiple
      hide-no-data
      :placeholder="placeholder"
      @change="updateValue"
    >
      <template v-slot:selection="{ attrs, item }">
        <v-chip
          color="primary"
          v-bind="attrs"
          close
          small
          class="mb-1 mr-1"
          @click:close="removeTag(item)"
          >{{ item }}
        </v-chip>
      </template></v-autocomplete
    >
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "SearchAutocomplete",
  data() {
    return {
      values: [],
    };
  },
  watch: {
    q(v) {
      this.$router
        .push({
          query: { ...this.$route.query, search: this.q || undefined },
        })
        .catch(() => {});
      this.debouncedQuery(v || "");
    },
  },
  props: {
    tags: {
      default: [],
    },
    placeholder: {
      default: "",
    },
  },
  computed: {
    // ...mapGetters(["getTags"]),
  },
  methods: {
    ...mapActions(["setTagQuery"]),
    updateValue(v) {
      this.setTagQuery(v);
    },
    clearTags() {
      this.values = [];
      this.setTagQuery(this.values);
    },
    removeTag(item) {
      // this.values.splice(this.values.indexOf(item), 1);
      this.values = this.values.filter((v) => v !== item);
      this.setTagQuery(this.values);
    },
  },
};
</script>

<style scoped lang="scss">
.search {
  margin: 20px 0 0;

  label {
    display: flex;
    align-items: center;
  }

  input {
    background-color: transparent;
    outline: none;
    border: 0 solid #ef3f37;
    border-bottom-width: 2px;
    width: 220px;
    position: relative;
    font-weight: 500;
    font-size: 15px;
    line-height: 30px;

    &::placeholder {
      opacity: 0.4;
    }
  }

  img {
    width: 26px;
    height: 26px;
    left: 100%;
    top: 0;
    margin-left: 8px;
  }
}

@media (max-width: 800px) {
  .search {
    margin: 40px 0 0;
  }
}
</style>
